import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import Head from '../../../../layout/head/Head';
import Content from '../../../../layout/content/Content';
import { Block, BlockBetween, BlockHead, BlockHeadContent, BlockTitle, Col, DataTableBody, DataTableHead, DataTableItem, DataTableRow, Icon, RSelect } from '../../../../components/Component';
import { Link } from 'react-router-dom';
import { Alert, Button, Card, Row } from 'reactstrap';
import CardTabs from '../../components/cards/CardTabs';
import AuthError from '../../../components/page_messaging/AuthError';
import AuthLoader from '../../../components/page_messaging/AuthLoader';
import { ADMIN_ADD_PRODCUT_UNIT_MEASUREMENT_DETAILS_API, ADMIN_DELETE_PRODCUT_UNIT_MEASUREMENT_DETAILS_API, ADMIN_UPDATE_PRODCUT_UNIT_MEASUREMENT_DETAILS_API, RETRIEVE_PRODUCTS_DETAILS_API, RETRIEVE_UNIT_MEASUREMENT_LIST } from '../../../../api/api_data';
import { fail_retrieve_product_details, loading_retrieve_product_details, reset_retrieve_product_details, success_retrieve_product_details } from '../../../../reducers/dashboard_reducers/products/retrieve_product_details_Slice';
import { ADD_PRODUCT_UNIT_MEASUREMENT_DETAILS_ACCESS_DENIED_MSG, ADD_PRODUCT_UNIT_MEASUREMENT_DETAILS_ERR_MSG, ADD_PRODUCT_UNIT_MEASUREMENT_DETAILS_SUCCESS_MSG, DELETE_PRODUCT_UNIT_MEASUREMENT_DETAILS_ACCESS_DENIED_MSG, DELETE_PRODUCT_UNIT_MEASUREMENT_DETAILS_ERR_MSG, DELETE_PRODUCT_UNIT_MEASUREMENT_DETAILS_SUCCESS_MSG, RETRIEVE_PRODUCTS_DETAILS_ACCESS_DENIED_MSG, RETRIEVE_PRODUCTS_DETAILS_ERR_MSG, RETRIEVE_PRODUCTS_DETAILS_SUCCESS_MSG, RETRIEVE_UNIT_MEASUREMENTS_LIST_ACCESS_DENIED_MSG, RETRIEVE_UNIT_MEASUREMENTS_LIST_ERR_MSG, RETRIEVE_UNIT_MEASUREMENTS_LIST_SUCCESS_MSG, UPDATE_PRODUCT_UNIT_MEASUREMENT_DETAILS_ACCESS_DENIED_MSG, UPDATE_PRODUCT_UNIT_MEASUREMENT_DETAILS_ERR_MSG, UPDATE_PRODUCT_UNIT_MEASUREMENT_DETAILS_SUCCESS_MSG } from '../../../../constants/success_error_messages_consts';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { employee_dashboard_actions_helper } from '../../../../actions/actions_helper';
import * as app_consts from "../../../../constants/react_app_consts";
import { messageToast } from '../../../../utils/Utils';
import ProfileDetailText from '../../components/text/ProfileDetailText';
import { formatNumber, formatToSentenceCase, getSelectedOption } from '../../../../utils/functionalUtils';
import { fail_unit_measurement_list, loading_unit_measurement_list, reset_unit_measurement_list, success_unit_measurement_list } from '../../../../reducers/dashboard_reducers/unit_measurement/unit_measurements_list_Slice';
import TextInput from '../../../components/inputs/TextInput';
import { fail_add_product_unit_measurement_details, loading_add_product_unit_measurement_details, reset_add_product_unit_measurement_details, success_add_product_unit_measurement_details } from '../../../../reducers/dashboard_reducers/products/add_product_unit_measurement_details_Slice';
import { fail_update_product_unit_measurement_details, loading_update_product_unit_measurement_details, reset_update_product_unit_measurement_details, success_update_product_unit_measurement_details } from '../../../../reducers/dashboard_reducers/products/update_product_unit_measurement_details_Slice';
import ModalConfirmCancel from '../../components/modal/modal_confirm_cancel/ModalConfirmCancel';
import { fail_delete_product_unit_measurement_details, loading_delete_product_unit_measurement_details, reset_delete_product_unit_measurement_details, success_delete_product_unit_measurement_details } from '../../../../reducers/dashboard_reducers/products/delete_product_unit_measurement_details_Slice';

const initialUomState = { unit_measurement_id: "", packet_size: "", base_weight_in_kilos: "", measurement_in_kilos: "" };
const intitialUpdateUomState = { old_packet_size: "", unit_measurement_id: "", packet_size: "", base_weight_in_kilos: "", measurement_in_kilos: "" };

const ProductDetails = () => {

  const { product_id } = useParams();
  const [loading, setLoading] = useState(true);
  const [activeCardTab, setActiveCardTab] = useState("Main Details");
  const [dataFetched, setDataFetched] = useState(false);
  const [page_data, setPageData] = useState([]);
  const [account_actions, setAccountActions] = useState([]);
  const dispatch = useDispatch();
  const [error, setError] = useState("");
  const [uom_details, setUomDetails] = useState();
  const [unit_measurement_loading, setUnitMeasurementLoading] = useState(false);
  const [unit_measurement_data, setUnitMeasurementData] = useState([]);
  const [formData, setFormData] = useState(initialUomState);
  const [add_uom_details_loading, setAddUomDetailsLoading] = useState(false);
  const [add_uom_error, setAddUomError] = useState("");
  const [edit_uom_loading, setEditUomLoading] = useState(false);
  const [edit_uom_error, setEditUomError] = useState("");
  const [delete_uom_loading, setDeleteUomLoading] = useState(false);
  const [delete_uom_error, setDeleteUomError] = useState("");
  const [update_form_data, setUpdateFormData] = useState(intitialUpdateUomState);
  const [edit_click, setEditClick] = useState(false);
  const [openConfirmCancelModal, setOpenConfirmCancelModal] = useState(false);
  const [selected_uom, setSelectedUom] = useState([]);

  // Card Tabs
  const tabs = [
    {
      tabName: "Main Details"
    },
    {
      tabName: "UOM Details"
    }
  ];

  //Retrieve Product List on Page Load
  useEffect(() => {
    retrieve_product_details();
    retrieve_unit_measurements_list();
    if (localStorage.getItem("log_cred"))
    {
      setAccountActions(JSON.parse(localStorage.getItem('log_cred'))?.user_actions);
    }
  }, []);

  const retrieve_product_details = () => {
    setError("");
    dispatch(
      employee_dashboard_actions_helper(
        loading_retrieve_product_details,
        success_retrieve_product_details,
        fail_retrieve_product_details,
        RETRIEVE_PRODUCTS_DETAILS_ERR_MSG,
        RETRIEVE_PRODUCTS_DETAILS_SUCCESS_MSG,
        app_consts.GET,
        `${RETRIEVE_PRODUCTS_DETAILS_API}/${product_id}`,
        null,
        RETRIEVE_PRODUCTS_DETAILS_ACCESS_DENIED_MSG
      )
    );
  };

  //Listen to State of Product List
  const retrieve_product_details_listener = useSelector((state) => state.retrieve_product_details.retrieve_product_details);

  useEffect(() => {
    if (retrieve_product_details_listener.status !== app_consts.IDLE)
    {
      if (retrieve_product_details_listener.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        setLoading(false);
        if (retrieve_product_details_listener.status === app_consts.FAIL)
        {
          messageToast(retrieve_product_details_listener.message, app_consts.FAIL);
          setError(retrieve_product_details_listener.message);
        } else if (retrieve_product_details_listener.status === app_consts.SUCCESS)
        {
          setPageData(retrieve_product_details_listener.data);
          setUomDetails(retrieve_product_details_listener.data?.pum_list || []);
        }
        dispatch(reset_retrieve_product_details());
      }
    }
  }, [retrieve_product_details_listener]);


  const retrieve_unit_measurements_list = () => {
    dispatch(
      employee_dashboard_actions_helper(
        loading_unit_measurement_list,
        success_unit_measurement_list,
        fail_unit_measurement_list,
        RETRIEVE_UNIT_MEASUREMENTS_LIST_ERR_MSG,
        RETRIEVE_UNIT_MEASUREMENTS_LIST_SUCCESS_MSG,
        app_consts.GET,
        RETRIEVE_UNIT_MEASUREMENT_LIST,
        null,
        RETRIEVE_UNIT_MEASUREMENTS_LIST_ACCESS_DENIED_MSG
      )
    );
  };

  //Listen to State of Unit Measurement List
  const unit_measurement_list = useSelector((state) => state.unit_measurement_list.unit_measurement_list);

  useEffect(() => {
    if (unit_measurement_list.status !== app_consts.IDLE)
    {
      if (unit_measurement_list.status === app_consts.LOADING)
      {
        setUnitMeasurementLoading(true);
      } else
      {
        setUnitMeasurementLoading(false);
        if (unit_measurement_list.status === app_consts.FAIL)
        {
          messageToast(unit_measurement_list.message, app_consts.FAIL);
        } else if (unit_measurement_list.status === app_consts.SUCCESS)
        {
          // Remap Unit Measurement Data
          const remapped_unit_measurement_data = unit_measurement_list?.data?.map((dat) => { return { ...dat, label: `${dat?.unit_measurement_full_name} (${dat?.unit_measurement_abbrev})`, value: dat?.unit_measurement_id }; });
          setUnitMeasurementData(remapped_unit_measurement_data);
        }
        dispatch(reset_unit_measurement_list());
      }
    }
  }, [unit_measurement_list]);

  const add_uom_details = () => {
    setAddUomError("");
    // Dispatch
    dispatch(
      employee_dashboard_actions_helper(
        loading_add_product_unit_measurement_details,
        success_add_product_unit_measurement_details,
        fail_add_product_unit_measurement_details,
        ADD_PRODUCT_UNIT_MEASUREMENT_DETAILS_ERR_MSG,
        ADD_PRODUCT_UNIT_MEASUREMENT_DETAILS_SUCCESS_MSG,
        app_consts.POST,
        ADMIN_ADD_PRODCUT_UNIT_MEASUREMENT_DETAILS_API,
        { ...formData, product_id: product_id },
        ADD_PRODUCT_UNIT_MEASUREMENT_DETAILS_ACCESS_DENIED_MSG
      )
    );
  };

  //Listen to State of Unit Measurement List
  const add_product_unit_measurement_details_list = useSelector((state) => state.add_product_unit_measurement_details.add_product_unit_measurement_details);

  useEffect(() => {
    if (add_product_unit_measurement_details_list.status !== app_consts.IDLE)
    {
      if (add_product_unit_measurement_details_list.status === app_consts.LOADING)
      {
        setAddUomDetailsLoading(true);
        setAddUomError("");
      } else
      {
        setAddUomDetailsLoading(false);
        if (add_product_unit_measurement_details_list.status === app_consts.FAIL)
        {
          setAddUomError(add_product_unit_measurement_details_list.message);
          messageToast(add_product_unit_measurement_details_list.message, app_consts.FAIL);
        } else if (add_product_unit_measurement_details_list.status === app_consts.SUCCESS)
        {
          setFormData(initialUomState);
          retrieve_product_details();
          messageToast(ADD_PRODUCT_UNIT_MEASUREMENT_DETAILS_SUCCESS_MSG, app_consts.SUCCESS);
        }
        dispatch(reset_add_product_unit_measurement_details());
      }
    }
  }, [add_product_unit_measurement_details_list]);


  const handleOnblur = (e) => {
    setFormData({ ...formData, [e.target.name]: parseFloat(e.target.value).toFixed(2) });
  };

  const onUpdateClick = (data) => {
    setUpdateFormData({ old_packet_size: data?.packet_size, base_weight_in_kilos: data?.base_weight_in_kilos, measurement_in_kilos: data?.measurement_in_kilos, packet_size: data?.packet_size, unit_measurement_id: data?.unit_measurement_id });
    setEditClick(true);
  };

  const update_uom_details = () => {
    setEditUomError("");
    // Dispatch
    dispatch(
      employee_dashboard_actions_helper(
        loading_update_product_unit_measurement_details,
        success_update_product_unit_measurement_details,
        fail_update_product_unit_measurement_details,
        UPDATE_PRODUCT_UNIT_MEASUREMENT_DETAILS_ERR_MSG,
        UPDATE_PRODUCT_UNIT_MEASUREMENT_DETAILS_SUCCESS_MSG,
        app_consts.POST,
        ADMIN_UPDATE_PRODCUT_UNIT_MEASUREMENT_DETAILS_API,
        { ...update_form_data, product_id: product_id },
        UPDATE_PRODUCT_UNIT_MEASUREMENT_DETAILS_ACCESS_DENIED_MSG
      )
    );
  };

  //Listen to State of Unit Measurement List
  const update_product_unit_measurement_details_list = useSelector((state) => state.update_product_unit_measurement_details.update_product_unit_measurement_details);

  useEffect(() => {
    if (update_product_unit_measurement_details_list.status !== app_consts.IDLE)
    {
      if (update_product_unit_measurement_details_list.status === app_consts.LOADING)
      {
        setEditUomLoading(true);
        setEditUomError("");
      } else
      {
        setEditUomLoading(false);
        if (update_product_unit_measurement_details_list.status === app_consts.FAIL)
        {
          setEditUomError(update_product_unit_measurement_details_list.message);
          messageToast(update_product_unit_measurement_details_list.message, app_consts.FAIL);
        } else if (update_product_unit_measurement_details_list.status === app_consts.SUCCESS)
        {
          setUpdateFormData(intitialUpdateUomState);
          retrieve_product_details();
          messageToast(UPDATE_PRODUCT_UNIT_MEASUREMENT_DETAILS_SUCCESS_MSG, app_consts.SUCCESS);
          setEditClick(false);
        }
        dispatch(reset_update_product_unit_measurement_details());
      }
    }
  }, [update_product_unit_measurement_details_list]);

  const delete_uom_details = () => {
    setDeleteUomError("");
    // Dispatch
    dispatch(
      employee_dashboard_actions_helper(
        loading_delete_product_unit_measurement_details,
        success_delete_product_unit_measurement_details,
        fail_delete_product_unit_measurement_details,
        DELETE_PRODUCT_UNIT_MEASUREMENT_DETAILS_ERR_MSG,
        DELETE_PRODUCT_UNIT_MEASUREMENT_DETAILS_SUCCESS_MSG,
        app_consts.POST,
        ADMIN_DELETE_PRODCUT_UNIT_MEASUREMENT_DETAILS_API,
        { ...selected_uom, product_id: product_id },
        DELETE_PRODUCT_UNIT_MEASUREMENT_DETAILS_ACCESS_DENIED_MSG
      )
    );
  };

  //Listen to State of Unit Measurement List
  const delete_product_unit_measurement_details_list = useSelector((state) => state.delete_product_unit_measurement_details.delete_product_unit_measurement_details);

  useEffect(() => {
    if (delete_product_unit_measurement_details_list.status !== app_consts.IDLE)
    {
      if (delete_product_unit_measurement_details_list.status === app_consts.LOADING)
      {
        setDeleteUomLoading(true);
        setDeleteUomError("");
      } else
      {
        setDeleteUomLoading(false);
        if (delete_product_unit_measurement_details_list.status === app_consts.FAIL)
        {
          setDeleteUomError(delete_product_unit_measurement_details_list.message);
          messageToast(delete_product_unit_measurement_details_list.message, app_consts.FAIL);
        } else if (delete_product_unit_measurement_details_list.status === app_consts.SUCCESS)
        {
          setUpdateFormData(intitialUpdateUomState);
          retrieve_product_details();
          messageToast(DELETE_PRODUCT_UNIT_MEASUREMENT_DETAILS_SUCCESS_MSG, app_consts.SUCCESS);
          setEditClick(false);
          setSelectedUom([]);
          setOpenConfirmCancelModal(false);
        }
        dispatch(reset_delete_product_unit_measurement_details());
      }
    }
  }, [delete_product_unit_measurement_details_list]);



  const open_delete_modal = () => {
    setOpenConfirmCancelModal(true);
  };

  return (
    <>
      <Head title="Product Details" />
      <Content>
        <BlockHead size="sm">
          <BlockBetween className="g-3">
            <BlockHeadContent>
              <BlockTitle page>{`Product Details`}</BlockTitle>
              <Link to={`/dashboard/admin/products`}>
                <Button color="light" outline className="bg-white d-none d-sm-inline-flex">
                  <Icon name="arrow-left"></Icon>
                  <span>Back</span>
                </Button>
              </Link>
              <Link to={`/dashboard/admin/products`}>
                <Button color="light" outline className="btn-icon bg-white d-inline-flex d-sm-none">
                  <Icon name="arrow-left"></Icon>
                </Button>
              </Link>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>


        <Block>
          <div className="card-aside-wrap" id="user-detail-block">
            <div className="card-content">
              {
                loading ?
                  <>
                    <AuthLoader loading_message="Loading Product Details..." />
                  </>
                  :
                  <>{
                    error && error.length > 0 ?
                      <>
                        <AuthError error_message={error} />
                      </>
                      :
                      <>
                        <Card>
                          <CardTabs cardTabs={tabs} activeCardTab={activeCardTab} setActiveCardTab={setActiveCardTab} dataFetched={setDataFetched} />

                          <div className="card-inner">
                            {
                              activeCardTab === "Main Details" &&
                              (
                                <>
                                  <Block>
                                    <BlockHead>
                                      <BlockTitle tag="h6">Main Details</BlockTitle>
                                    </BlockHead>
                                    <div className="profile-ud-list">
                                      <ProfileDetailText label="Product Name" text={page_data?.product_name || "---"} />
                                      <ProfileDetailText label="Product Type" text={page_data?.product_type || "---"} />
                                      <ProfileDetailText label="Status" text={page_data?.account_status || "---"} textClassName={page_data?.account_status === formatToSentenceCase(app_consts.ACTIVE_LOWER) ? "text-success" : "text-warning"} />
                                    </div>
                                  </Block>
                                </>
                              )
                            }
                            {
                              activeCardTab === "UOM Details" &&
                              (
                                <>
                                  <Block>
                                    <BlockHead>
                                      <BlockTitle tag="h5">Unit of Measure Details</BlockTitle>
                                      <p>Product Packet Size and Measurement Details</p>
                                    </BlockHead>

                                    {add_uom_error && (
                                      <div className="mb-3 w-100">
                                        <Alert color="danger" className="alert-icon">
                                          <Icon name="alert-circle" /> {add_uom_error}{" "}
                                        </Alert>
                                      </div>
                                    )}
                                    <div className="nk-tb-list is-separate is-medium mt-1 mb-3">

                                      <DataTableHead className="nk-tb-item">
                                        <DataTableRow size="lg"><span className="sub-text">Unit Measurement</span></DataTableRow>
                                        <DataTableRow size="lg"><span className="sub-text">Packet Size</span></DataTableRow>
                                        <DataTableRow size="lg"><span className="sub-text">Base Weight (KGs)</span></DataTableRow>
                                        <DataTableRow size="lg"><span className="sub-text">Density Weight (KGs)</span></DataTableRow>
                                        <DataTableRow size="lg"><span className="sub-text">Action</span></DataTableRow>
                                      </DataTableHead>

                                      <DataTableItem>
                                        <DataTableRow>
                                          <RSelect
                                            options={unit_measurement_data}
                                            className="w-100"
                                            placeholder="Search"
                                            id="product_type"
                                            onChange={(e) => setFormData({ ...formData, unit_measurement_id: e.value, packet_size: "", base_weight_in_kilos: "", measurement_in_kilos: "" })}
                                            isDisabled={unit_measurement_loading}
                                            value={getSelectedOption(formData?.unit_measurement_id, unit_measurement_data)}
                                          />
                                        </DataTableRow>
                                        <DataTableRow>
                                          <Row className="g-4">
                                            <TextInput
                                              required
                                              type="text"
                                              value={formData?.packet_size}
                                              colSize="10"
                                              handleChange={(e) => setFormData({ ...formData, packet_size: e.target.value, base_weight_in_kilos: "", measurement_in_kilos: "" })}
                                              disabled={!formData?.unit_measurement_id}
                                              name="packet_size"
                                            />
                                          </Row>
                                        </DataTableRow>
                                        <DataTableRow>
                                          <Row className="g-4">
                                            <TextInput
                                              required
                                              type="number"
                                              min={0}
                                              value={formData?.base_weight_in_kilos}
                                              colSize="10"
                                              disabled={!formData?.packet_size}
                                              onBlur={handleOnblur}
                                              handleChange={(e) => setFormData({ ...formData, base_weight_in_kilos: e.target.value, measurement_in_kilos: "" })}
                                              name="base_weight_in_kilos"
                                            />
                                          </Row>
                                        </DataTableRow>
                                        <DataTableRow>
                                          <Row className="g-4">
                                            <TextInput
                                              required
                                              type="number"
                                              min={0}
                                              value={formData?.measurement_in_kilos}
                                              colSize="10"
                                              disabled={!formData?.base_weight_in_kilos}
                                              onBlur={handleOnblur}
                                              handleChange={(e) => setFormData({ ...formData, measurement_in_kilos: e.target.value })}
                                              name=""
                                            />
                                          </Row>
                                        </DataTableRow>
                                        <DataTableRow>
                                          <Button color="primary"
                                            disabled={edit_uom_loading || add_uom_details_loading || delete_uom_loading || !(formData?.unit_measurement_id && formData?.packet_size && formData?.base_weight_in_kilos && formData?.measurement_in_kilos)}
                                            size="sm" onClick={add_uom_details}>{add_uom_details_loading ? "Adding..." : "Add"}</Button>
                                        </DataTableRow>
                                      </DataTableItem>

                                    </div>
                                    <div className="nk-tb-list is-separate is-medium mt-1 mb-3">
                                      <div className="card-inner p-0">
                                        {uom_details.length > 0 &&
                                          uom_details.map((item) => (
                                            <>
                                              <div className='d-flex '>
                                                <BlockTitle tag="h6">{formatToSentenceCase(item?.unit_measurement_full_name) || ""}</BlockTitle>
                                                <p className='mx-2'>{item?.unit_measurement_abbrev ? `(${formatToSentenceCase(item?.unit_measurement_abbrev)})` : ""}</p>
                                              </div>
                                              {/* Map Products */}
                                              {/* Map Products */}
                                              <DataTableBody>
                                                <DataTableHead className="nk-tb-item">
                                                  <DataTableRow size="lg"><span className="sub-text">Packet Size</span></DataTableRow>
                                                  <DataTableRow size="lg"><span className="sub-text">Base Weight (KGs)</span></DataTableRow>
                                                  <DataTableRow size="lg"><span className="sub-text">Density Weight (KGs)</span></DataTableRow>
                                                  {
                                                    edit_click ?
                                                      <>
                                                        <DataTableRow size="lg"><span className="sub-text">Cancel</span></DataTableRow>
                                                        <DataTableRow size="lg"><span className="sub-text">Edit</span></DataTableRow>
                                                      </>
                                                      :
                                                      <>
                                                        <DataTableRow size="lg"><span className="sub-text">Edit</span></DataTableRow>
                                                        <DataTableRow size="lg"><span className="sub-text">Delete</span></DataTableRow>
                                                      </>
                                                  }
                                                </DataTableHead>
                                                {edit_uom_error && edit_click && update_form_data?.unit_measurement_id === item?.unit_measurement_id && (
                                                  <div className="mb-3 w-100">
                                                    <Alert color="danger" className="alert-icon">
                                                      <Icon name="alert-circle" /> {edit_uom_error}{" "}
                                                    </Alert>
                                                  </div>
                                                )}
                                                {item?.uom_details?.length > 0 &&
                                                  item?.uom_details?.map((uom) => (
                                                    <DataTableItem key={item.id}>
                                                      <DataTableRow>
                                                        {
                                                          edit_click && update_form_data?.old_packet_size === uom?.packet_size && update_form_data?.unit_measurement_id === item?.unit_measurement_id ?
                                                            <>
                                                              <Row className="g-4">
                                                                <TextInput
                                                                  required
                                                                  type="text"
                                                                  value={update_form_data?.packet_size}
                                                                  colSize="10"
                                                                  handleChange={(e) => setUpdateFormData({ ...update_form_data, packet_size: e.target.value })}
                                                                  name="packet_size"
                                                                />
                                                              </Row>
                                                            </>
                                                            :
                                                            <>
                                                              <span className="tb-sub">{uom?.packet_size || "--"}</span>
                                                            </>
                                                        }
                                                      </DataTableRow>
                                                      <DataTableRow>
                                                        {
                                                          edit_click && update_form_data?.old_packet_size === uom?.packet_size && update_form_data?.unit_measurement_id === item?.unit_measurement_id ?
                                                            <>
                                                              <Row className="g-4">
                                                                <TextInput
                                                                  required
                                                                  type="number"
                                                                  min={0}
                                                                  value={update_form_data?.base_weight_in_kilos}
                                                                  colSize="10"
                                                                  onBlur={handleOnblur}
                                                                  handleChange={(e) => setUpdateFormData({ ...update_form_data, base_weight_in_kilos: e.target.value })}
                                                                  name=""
                                                                />
                                                              </Row>
                                                            </>
                                                            :
                                                            <>
                                                              <span className="tb-sub">{uom?.base_weight_in_kilos ? formatNumber(uom?.base_weight_in_kilos) : "Not Set"}</span>
                                                            </>
                                                        }
                                                      </DataTableRow>
                                                      <DataTableRow>
                                                        {
                                                          edit_click && update_form_data?.old_packet_size === uom?.packet_size && update_form_data?.unit_measurement_id === item?.unit_measurement_id ?
                                                            <>
                                                              <Row className="g-4">
                                                                <TextInput
                                                                  required
                                                                  type="number"
                                                                  min={0}
                                                                  value={update_form_data?.measurement_in_kilos}
                                                                  colSize="10"
                                                                  onBlur={handleOnblur}
                                                                  handleChange={(e) => setUpdateFormData({ ...update_form_data, measurement_in_kilos: e.target.value })}
                                                                  name=""
                                                                />
                                                              </Row>
                                                            </>
                                                            :
                                                            <>
                                                              <span className="tb-sub">{uom?.measurement_in_kilos ? formatNumber(uom?.measurement_in_kilos) : "Not Set"}</span>
                                                            </>
                                                        }
                                                      </DataTableRow>
                                                      {
                                                        edit_click ?
                                                          <>
                                                            {
                                                              update_form_data?.old_packet_size === uom?.packet_size && update_form_data?.unit_measurement_id === item?.unit_measurement_id && (
                                                                <>
                                                                  <DataTableRow>
                                                                    <Button color="light"
                                                                      size="sm" onClick={() => setEditClick(false)}>Cancel</Button>
                                                                  </DataTableRow>
                                                                  <DataTableRow>
                                                                    <Button color="primary" onClick={() => update_uom_details()} disabled={edit_uom_loading || !(update_form_data?.base_weight_in_kilos && update_form_data?.packet_size && update_form_data?.measurement_in_kilos)}
                                                                      size="sm">{edit_uom_loading ? "Editing..." : "Edit"}</Button>
                                                                  </DataTableRow>
                                                                </>
                                                              )
                                                            }
                                                          </>
                                                          :
                                                          <>
                                                            <DataTableRow>
                                                              <span className={`tb-lead-sub text`}
                                                                onClick={() => {
                                                                  onUpdateClick({ unit_measurement_id: item?.unit_measurement_id, packet_size: uom?.packet_size, base_weight_in_kilos: uom?.base_weight_in_kilos, measurement_in_kilos: uom?.measurement_in_kilos });
                                                                }}>
                                                                <Icon name="edit-alt" className="text-primary fs-22px" style={{ cursor: "pointer" }} />
                                                              </span>
                                                            </DataTableRow>
                                                            <DataTableRow>

                                                              <span className={`tb-lead-sub text`}
                                                                onClick={() => {
                                                                  open_delete_modal();
                                                                  setSelectedUom({ unit_measurement_id: item?.unit_measurement_id, packet_size: uom?.packet_size, base_weight_in_kilos: uom?.base_weight_in_kilos, measurement_in_kilos: uom?.measurement_in_kilos, unit_measurement_full_name: item?.unit_measurement_full_name });
                                                                }}>
                                                                <Icon name="trash-fill" className="text-danger fs-22px" style={{ cursor: "pointer" }} />
                                                              </span>
                                                            </DataTableRow>
                                                          </>
                                                      }
                                                    </DataTableItem>
                                                  ))}
                                              </DataTableBody>
                                            </>
                                          ))
                                        }
                                      </div>
                                    </div>
                                  </Block>
                                </>
                              )
                            }
                          </div>
                        </Card>


                        {/* Yes or No Modal */}
                        <ModalConfirmCancel
                          openModal={openConfirmCancelModal}
                          setOpenModal={setOpenConfirmCancelModal}
                          modalTitle={`Delete ${selected_uom?.packet_size} of ${selected_uom?.unit_measurement_full_name}?`}
                          modalDescription={`Are you sure that you want to Delete ${selected_uom?.packet_size} of ${selected_uom?.unit_measurement_full_name} Details?`}
                          buttonConfirm="Confirm"
                          buttonCancel="Cancel"
                          succFunc={delete_uom_details}
                          errAmend={delete_uom_error}
                          setErrAmend={setDeleteUomError}
                        />
                      </>
                  }
                  </>
              }
            </div>
          </div>
        </Block>

      </Content>

    </>
  );
};

export default ProductDetails;